import PropTypes from 'prop-types';
import useLiterals from 'utils/hooks/useLiterals';
import Box from 'components/UI/Box/Box';
import StepsProgress from 'components/UI/StepsProgress';
import Button from 'components/UI/Button';
import MercadoLibreImg from 'assets/images/mercado_libre.jpg';
import MercadoPagoImg from 'assets/images/mercado_pago.jpg';
import { ReactComponent as FinsusLogo } from 'assets/logos/logo_finsus.svg';
import { PROVIDER_TYPE } from 'constants/global';
import { useMercadoPagoVisible } from 'modules/mercadopago/useMercadoPagoVisible';
import useFeatureGate from 'utils/hooks/useFeatureGate';
import { FEATURE_FINSUS } from 'constants/featureGates';

const PaymentMethod = ({
  step, steps, onChange, changeStep, paymentMethod,
}) => {
  const { paymentMethodStep: literals } = useLiterals('paymentGateway');
  const { visible: showMercadoPago } = useMercadoPagoVisible();
  const finsusEnabled = useFeatureGate(FEATURE_FINSUS);

  const handleMercadoPagoClick = () => {
    onChange(PROVIDER_TYPE.MERCADO_PAGO);
  };

  const renderPaymentMethods = () => {
    return (
      <>
        <div className='flex gap-2 mb-2'>
          <Box className='w-1/2'>
            <img src={MercadoLibreImg} alt='Mercado Libre' className='payment-logo w-full' />
          </Box>
          {showMercadoPago && (
            <Box
              className={`w-1/2 ${paymentMethod === PROVIDER_TYPE.MERCADO_PAGO ? 'selected' : ''}`}
              onClick={handleMercadoPagoClick}
              style={{ cursor: 'pointer' }}
            >
              <img src={MercadoPagoImg} alt='Mercado Pago' className='payment-logo w-full' />
            </Box>
          )}
        </div>
        {finsusEnabled && (
          <div className='flex gap-2 mb-2'>
            <Box className='w-1/2'>
              <FinsusLogo className='payment-logo' />
            </Box>
          </div>
        )}
      </>
    );
  };

  return (
    <Box>
      <div className='payment-methods'>
        <h3 className='my-0 font-normal'>{literals.title}</h3>
        <h1 className='text-primary my-2'>{literals.paymentMethod}</h1>
        <StepsProgress steps={steps} current={step} className='w-full mb-6' />
        <h3 className='mb-2'>{literals.subtitle}</h3>
        {renderPaymentMethods()}
        <Button
          className='w-full mt-4'
          text={literals.payWithCard}
          onClick={() => changeStep(step + 1)}
        />
      </div>
    </Box>
  );
};

PaymentMethod.propTypes = {
  step: PropTypes.number.isRequired,
  steps: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  changeStep: PropTypes.func.isRequired,
  paymentMethod: PropTypes.string,
};

export default PaymentMethod;
